import { useState } from 'react';
import type { SortDirection } from '@api/backoffice';

export function useBackofficeSort<K extends string>(defaultKey: K) {
  const [sortKey, setSortKey] = useState<K>(defaultKey);
  const [sortDirection, setSortDirection] = useState<SortDirection>('desc');

  const toggleSort = (key: K) => {
    const newDir = key === sortKey ? (sortDirection === 'asc' ? 'desc' : 'asc') : 'asc';
    setSortKey(key);
    setSortDirection(newDir);
  };

  return { sortKey, sortDirection, toggleSort } as const;
}
